import axios from "axios";
import Auth from "../Auth";
import store from "@/store";
import { getCartSessionId } from "@/utils/session";
const API_URL = process.env.VUE_APP_API_URL;
// Create axios instance with default config
const http = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add session ID to all requests automatically
http.interceptors.request.use((config) => {
  const countryCode =
    store.getters["country/countryCode"] || localStorage.country;
  config.headers["X-Cart-Session"] = getCartSessionId();
  config.headers.country = countryCode;
  config.headers.accept = "application/json";
  return config;
});

// Handle session ID in responses
http.interceptors.response.use((response) => {
  if (response.data?.data?.cart_session_id) {
    localStorage.setItem("cart_session_id", response.data.data.cart_session_id);
  }
  return response;
});

const HttpService = {
  async get(endpoint, params = "", withAuth = false) {
    const headers = {};

    if (withAuth && typeof localStorage.AUTH_TOKEN !== "undefined") {
      headers.Authorization = "Bearer " + localStorage.AUTH_TOKEN;
    }

    const url = params ? `${endpoint}${params}` : endpoint;

    return http.get(url, { headers });
  },

  async post(endpoint, body = {}, withAuth = false) {
    const headers = {};

    if (withAuth && typeof localStorage.AUTH_TOKEN !== "undefined") {
      headers.Authorization = "Bearer " + localStorage.AUTH_TOKEN;
    }

    return http.post(endpoint, body, { headers });
  },

  async put(endpoint, body = {}, withAuth = false) {
    const headers = {};

    if (withAuth && typeof localStorage.AUTH_TOKEN !== "undefined") {
      headers.Authorization = "Bearer " + localStorage.AUTH_TOKEN;
    }

    return http.put(endpoint, body, { headers });
  },

  async delete(endpoint, withAuth = false) {
    const headers = {};

    if (withAuth && typeof localStorage.AUTH_TOKEN !== "undefined") {
      headers.Authorization = "Bearer " + localStorage.AUTH_TOKEN;
    }

    return http.delete(endpoint, { headers });
  },

  // Add this method to handle file uploads if needed
  async upload(endpoint, formData, withAuth = false) {
    const headers = {
      "Content-Type": "multipart/form-data",
    };

    if (withAuth && typeof localStorage.AUTH_TOKEN !== "undefined") {
      headers.Authorization = "Bearer " + localStorage.AUTH_TOKEN;
    }

    return http.post(endpoint, formData, { headers });
  },
};

export default HttpService;
